const findCommonItemsReduceFilter = arrayOfArrays => {
  if (arrayOfArrays.length === 0) {
    return []
  }

  const commonItems = arrayOfArrays
    .slice(1)
    .reduce((accumulator, currentArray) => {
      const currentNames = new Set(currentArray.map(item => item.name))
      return accumulator.filter(item => currentNames.has(item.name))
    }, arrayOfArrays[0])
  return commonItems.map(item => ({ name: item.name, swatch: item.swatch }))
}

export const getCommonColorDetails = data => {
  const { bundleItems = [], selectedMasterSkus = [] } = data || {}
  const initSelectedMasterSkus = bundleItems.map((item = {}) => {
    const { products = [] } = item
    const { masterSku = "" } = products.at(0) || {}
    return masterSku
  })

  const selectedSkus = selectedMasterSkus.length
    ? selectedMasterSkus
    : initSelectedMasterSkus || []

  const variantColorList = []
  selectedSkus.forEach(sku => {
    bundleItems.forEach(item => {
      const { colorDetails } =
        item.products.find(product => product.masterSku === sku) || {}
      colorDetails && variantColorList.push(colorDetails)
    })
  })
  return findCommonItemsReduceFilter(variantColorList)
}

export const getSelectedProductPrices = (data = {}) => {
  const { productLists = [], skus = [], currencyCode = "", persona = "" } = data
  return skus.map(sku => {
    const item =
      productLists.find(
        p => p.masterVariant.sku === sku || p.variants.find(v => v.sku === sku)
      ) || {}

    const {
      masterVariant: { sku: masterSku = "", prices = "" } = {},
      variants = [],
    } = item
    let responseProduct = []
    if (masterSku && masterSku === sku) {
      responseProduct = prices
    } else {
      responseProduct = variants.filter(variant => variant.sku === sku)?.[0]
        ?.prices
    }
    const fixedPromo = responseProduct?.find(
      price =>
        price.value?.currencyCode === currencyCode &&
        price.customerGroup?.obj?.key === persona &&
        price.custom?.fields?.fixedPrice
    )
    const productPrice = responseProduct?.find(
      price =>
        price.value?.currencyCode === currencyCode &&
        price.customerGroup?.obj?.key === persona
    )

    let priceObj = fixedPromo || productPrice
    if (!priceObj?.value) {
      priceObj = responseProduct?.find(
        price =>
          price.value?.currencyCode === currencyCode && !price.customerGroup
      )
    }

    const priceProduct =
      Number(((priceObj?.value?.centAmount ?? 0) / 100).toFixed(2)) || 0

    const discountPrice =
      Number((priceObj?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2) ||
      0

    return {
      sku,
      priceProduct,
      discountPrice,
    }
  })
}

export const getSelectedImageGallaryDetails = (
  data = {},
  selectedSkus = []
) => {
  const imageDetailsInfo = []
  selectedSkus.forEach(sku => {
    Object.entries(data)?.map(([key, value]) => {
      const colorInfo = value.filter(item => {
        const productSkuKey = sku?.split("-").slice(0, -1).join("-")
        return (
          item.sku.includes(productSkuKey) ||
          item.masterSKU.includes(productSkuKey)
        )
      })
      if (colorInfo.length === 0) return null
      imageDetailsInfo.push(Object(colorInfo[0]))
    })
  })
  return imageDetailsInfo
}

export const getImageGalleryData = (data = {}, selectedSkus = "") => {
  const imageDetailsInfo = []
  let videoDeatilsInfo = []
  if (data?.ProductImageURL) {
    data?.ProductImageURL.map(item => {
      const eachspliteditem = item?.split("|")
      if (eachspliteditem[0] === selectedSkus) {
        imageDetailsInfo.push({
          label: eachspliteditem[4],
          // remove the space from the string
          assetId: eachspliteditem[1].replace(/\s+/g, ""),
          url: eachspliteditem[5],
        })
      }
    })
    videoDeatilsInfo = data.ProductVideoID.split("|").map(item => {
      return {
        type: "video",
        url: item,
      }
    })
  }
  const imageVideo = { imageDetailsInfo, videoDeatilsInfo } || {}
  return imageVideo?.imageDetailsInfo
}

export const getAllImage = (
  selectedSkusDetails = [],
  selectedImageDetails = []
) => {
  const intialimages = []
  const restimage = []
  const videos = []
  selectedSkusDetails.forEach(item => {
    item?.ProductVideoID?.split("|").forEach(video => {
      if (video) {
        videos.push({
          type: "video",
          url: video,
        })
      }
    })
  })

  selectedImageDetails?.forEach(item => {
    if (item.length !== 0) {
      intialimages.push(item[0])
      restimage.push(...item.splice(1))
    }
  })
  const allImages = [
    ...intialimages,
    // ...restimage, // Uncomment if you want to include rest images
    ...videos,
  ]
  return { allImages, intialimages }
}
export const getLayeredImage = (
  intialimages = [],
  bundleImageURL = [],
  selectedSkus = []
) => {
  let imageURL = bundleImageURL
  if (intialimages.length === selectedSkus.length) {
    intialimages.forEach((item, index) => {
      const imageindex = `<<IMAGE${index + 1}>>`
      imageURL = imageURL.replace(imageindex, item?.assetId)
    })
    return imageURL
  } else {
    return ""
  }
}

export const getSelectedProductData = data => {
  const { bundleItems = [], selectedProducts = [], skusPrice = "" } = data || {}

  const priceMap = {}
  skusPrice?.forEach(item => {
    priceMap[item.sku] =
      Number(item.discountPrice) || Number(item.priceProduct) || 0
  })
  const selectedSkus = selectedProducts?.map(item => item?.sku)

  const productData = bundleItems
    .flatMap(item => item.products)
    .map(product => {
      const { colorDetails = [], imageDetails = [], title = "" } = product || {}
      const { sku = "", name = "" } =
        colorDetails.find(item => selectedSkus.includes(item.sku)) || {}

      if (!sku) return null

      const unitPrice = priceMap[sku] || 0
      const { imageUrl } = imageDetails.find(item => item.sku === sku) || {}
      const imageUrlPath = `${imageUrl}?wid=80&hei=80&bgc=f9f9f9`

      return {
        productName: title || "",
        color: name || "",
        image: imageUrlPath,
        quantity: 1,
        unitPrice: unitPrice || 0,
        sku: sku || "",
      }
    })
    .filter(Boolean)

  return productData
}

export const isSkuBackOrderable = ({ data = [], sku = "" }) => {
  let isBackorderableValue = false
  data?.forEach(each => {
    const allVariants = each?.variants.concat(each?.masterVariant)
    allVariants?.forEach(item => {
      if (item.sku === sku) {
        const { attributes } = item
        const isBackorderable = attributes?.find(
          attribute => attribute.name === "RegionIsBackorderable"
        )
        isBackorderableValue = isBackorderable?.value
      }
    })
  })
  return isBackorderableValue
}

export const getSelectedbundleDetails = ({ data = {}, selectedSkus = [] }) => {
  const productDetailsInfo = []
  selectedSkus.forEach(sku => {
    data.map(each => {
      const productSkuKey = sku?.split("-").slice(0, -1).join("-")
      const selectedItemDetails = each?.products?.filter(item => {
        const isMatched =
          item?.sku.includes(productSkuKey) ||
          item?.masterSku.includes(productSkuKey)
        return isMatched
      })
      if (selectedItemDetails.length !== 0)
        productDetailsInfo.push(selectedItemDetails[0])
    })
  })
  return productDetailsInfo
}

export const getAddToCartItems = (
  selectedProducts = [],
  bundleItems = [],
  projectionData = [],
  quantity = 1,
  bundleAnalyticsData = []
) => {
  const selectedProductsData = selectedProducts.map(selected => {
    const { products = [] } = bundleItems.find(
      item => item.name === selected.name
    )
    const { productType = "" } = products.find(product => {
      return product.masterSku === selected.masterSku
    })
    const isBackorderable = isSkuBackOrderable({
      data: projectionData,
      sku: selected.sku,
    })
    return {
      sku: selected.sku,
      isComboSku: productType === "engineer-bundle",
      backorder: isBackorderable,
    }
  })
  const items = selectedProductsData.map(selectedProduct => {
    const { isComboSku = false, sku = "", backorder = false } = selectedProduct
    return {
      sku,
      quantity,
      isBundleProduct: false,
      isBundle: isComboSku,
      selectedBundlesProduct: bundleAnalyticsData || null,
      backorder,
    }
  })
  return items
}

export const checkIsAllProductsAvailable = (
  selectedProducts = [],
  projectionData = []
) => {
  return selectedProducts?.every(item => {
    const isBackorderable = isSkuBackOrderable({
      data: projectionData,
      sku: item.sku,
    })
    return isBackorderable || item.isInventory
  })
}

export const getStickyHeaderProps = (
  state,
  staticTexts,
  availableColors,
  swatchName
) => {
  const { pdpDetails = {}, projectionData = [], selectedProducts = [] } = state
  const { name: title = "", desc: description = "" } = pdpDetails
  const color = availableColors.find(item => item.label === swatchName) || {}
  const isAllProductsAvailable = checkIsAllProductsAvailable(
    selectedProducts,
    projectionData
  )
  return {
    stickyHeaderProps: {
      title,
      description,
      color: {
        label: color.label || "",
        url: color.colorUrl || "",
      },
    },
    staticTexts: {
      addToCart: staticTexts?.addToCartLabel || "",
    },
    disableBundleAddToCart: !isAllProductsAvailable,
    isRegionSoldOnline: true,
    isDiscontinued: false,
    disableEcommerce: false,
    handleScroll: () => {},
    onAvailableColor: () => {},
  }
}

export const processImageData = (
  bundleListImages,
  selectedSkus,
  bundleIMageURL
) => {
  const selectedSkusDetails = getSelectedImageGallaryDetails(
    bundleListImages,
    selectedSkus
  )
  const selectedImageDetails = selectedSkus.map((sku, index) => {
    return getImageGalleryData(selectedSkusDetails[index], sku)
  })
  const { allImages, intialimages } = getAllImage(
    selectedSkusDetails,
    selectedImageDetails
  )
  const imageURL = getLayeredImage(intialimages, bundleIMageURL, selectedSkus)
  return { allImages, imageURL }
}
